const $ = (css, parent = document) => parent.querySelector(css);
const $$ = (css, parent = document) => parent.querySelectorAll(css);

if (window.sfEnv.isDesignMode) {
  import('./backend-tweaks').then(() => {
    // console.log('Loaded backend tweaks')
  });
}

function uppercasePhiniaText(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    node.nodeValue = node.nodeValue.replace(/Phinia/g, 'PHINIA');
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (let child of node.childNodes) {
      uppercasePhiniaText(child);
    }
  }
}

uppercasePhiniaText(document.body);

// let headerNav = document.getElementById('header-nav')
let headerNav = document.querySelector('header');
let root = $(':root');
const resizeObserver = new ResizeObserver(entries => {
  for (let entry of entries) {
    if (entry.target === headerNav) {
      let box = headerNav.getBoundingClientRect();
      root.style.setProperty('--offcanvas-top', `${box.height}px`);
    }
  }
});
resizeObserver.observe(headerNav);

let closeActiveOffcanvas = $('.close-active-offcanvas');
let mobileNavOffcanvasToggle = $('.mobile-nav-offcanvas-toggle');

let activeOffcanvas = null;

$$('[uk-offcanvas]').forEach(offcanvas => {
  let toggles = [];

  setTimeout(() => {
    headerNav.querySelectorAll('[uk-toggle]').forEach(toggle => {
      if (toggle.__uikit__ && toggle.__uikit__['toggle']) {
        if (toggle.__uikit__['toggle'].target[0] === offcanvas) {
          toggles.push(toggle);
        }
      }
    });
  }, 0);

  //	Fires after an item is shown.
  offcanvas.addEventListener('show', function () {
    activeOffcanvas = offcanvas;
    closeActiveOffcanvas.classList.remove('uk-hidden');

    if (
      offcanvas.id === window.sfEnv.searchOffcanvasId ||
      offcanvas.id === window.sfEnv.mobileLanguageSelectorModalWindowOffcanvasId
    ) {
      mobileNavOffcanvasToggle.classList.add('uk-visible@m');
    }

    toggles.forEach(t => {
      t.classList.add('uk-visible@m');
    });
  });

  //Fires after an item's hide animation has started.
  offcanvas.addEventListener('hide', function () {
    activeOffcanvas = null;
    closeActiveOffcanvas.classList.add('uk-hidden');
    // const regionModalWindowState = localStorage.getItem('region-modal-window-state')

    if (
      offcanvas.id === window.sfEnv.searchOffcanvasId ||
      offcanvas.id === window.sfEnv.mobileLanguageSelectorModalWindowOffcanvasId
    ) {
      mobileNavOffcanvasToggle.classList.remove('uk-visible@m');
    }

    if (
      offcanvas.id === window.sfEnv.mobileLanguageSelectorModalWindowOffcanvasId
    ) {
      localStorage.setItem('region-modal-window-state', 'closed');
    }

    toggles.forEach(t => {
      t.classList.remove('uk-visible@m');
    });

    setTimeout(() => {
      document.body.style.height = 'auto';
      document.body.style.overflowY = 'auto';
      document.documentElement.style.overflowY = 'auto';
    }, 0);
  });
});

closeActiveOffcanvas.addEventListener('click', () => {
  if (!activeOffcanvas) throw new Error('No offcanvas to close');
  UIkit.offcanvas(activeOffcanvas).hide();
  $$('.mobile-sub-menu').forEach(e => {
    e.classList.remove('expanded');
  });
});

let sfRoles = {};

$$('[data-sf-role]').forEach(e => {
  sfRoles[e.dataset.sfRole] = e.value;
});

const setLanguageModalWindowState = state => {
  localStorage.setItem('region-modal-window-state', state);
};
const hideLanguageModalWindow = () => {
  setLanguageModalWindowState('closed');
  toggleLanguageModalWindow();
};
const toggleLanguageModalWindow = () => {
  const mobileModalWindow = $('.modal-window-language-selector-mobile');
  const desktopModalWindow = $('.modal-window-language-selector-desktop');
  const navigationIcons = $('#header-nav .navigation-icons');
  const languageSelectorButton = $(
    'header [uk-toggle="target:#lang-ce6687e1-6228-4243-b9c8-2e5cc510bec2"]'
  );
  const regionModalWindowStateAfterResize = localStorage.getItem(
    'region-modal-window-state'
  );
  const isLargeDesktop = window.innerWidth > 1140;
  if (isLargeDesktop) {
    mobileModalWindow.style.display = 'none';
    navigationIcons.style.display = 'block';
    languageSelectorButton.style.display = 'block';
    if (regionModalWindowStateAfterResize !== 'closed') {
      // show desktop modal window and disable page scrolling
      desktopModalWindow.style.display = 'block';
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      // hide desktop modal window and enable page scrolling
      desktopModalWindow.style.display = 'none';
      document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
  } else {
    desktopModalWindow.style.display = 'none';
    if (regionModalWindowStateAfterResize !== 'closed') {
      // show mobile modal window and hide clickable icons in the header
      mobileModalWindow.style.display = 'block';
      navigationIcons.style.display = 'none';
      languageSelectorButton.style.display = 'none';
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      // hide mobile modal window and show clickable icons in the header
      mobileModalWindow.style.display = 'none';
      navigationIcons.style.display = 'block';
      languageSelectorButton.style.display = 'block';
      document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
  }
};
const manageLanguageModalWindow = () => {
  const modalWindowMobileCloseButton = $(
    '#modal-window-language-selector-mobile-close-button'
  );
  const modalWindowDesktopCloseButton = $(
    '#modal-window-language-selector-desktop-close-button'
  );
  const modalWindowDesktopOutsideSection = $(
    '#modal-window-language-selector-desktop-outside-section'
  );
  toggleLanguageModalWindow();
  $$('#mobile-langModalWindow-d59db2ae-6952-47a4-88c2-6f09ec6dafcb a').forEach(
    link => {
      link.addEventListener('click', () =>
        setLanguageModalWindowState('closed')
      );
    }
  );
  $$('#modal-window-language-selector-desktop a').forEach(link => {
    link.addEventListener('click', () => setLanguageModalWindowState('closed'));
  });
  if (modalWindowMobileCloseButton) {
    modalWindowMobileCloseButton.addEventListener(
      'click',
      hideLanguageModalWindow
    );
  }
  if (modalWindowDesktopCloseButton) {
    modalWindowDesktopCloseButton.addEventListener(
      'click',
      hideLanguageModalWindow
    );
  }
  if (modalWindowDesktopOutsideSection) {
    modalWindowDesktopOutsideSection.addEventListener(
      'click',
      hideLanguageModalWindow
    );
  }
  $$(
    '#modal-window-language-selector-desktop-and-mobile .modal-window-language-selector-redirect-button'
  ).forEach(link => {
    const region = link.pathname.split('/')[1];
    link.addEventListener('click', () => setRegionCookie(region));
  });
  $$(
    '#modal-window-language-selector-desktop-and-mobile .language-link[data-culture]'
  ).forEach(li => {
    const region = li.dataset.region;
    li.addEventListener('click', () => setRegionCookie(region));
  });
  window.addEventListener('resize', toggleLanguageModalWindow);
};

document.addEventListener('DOMContentLoaded', () => {
  const regionCookie = document.cookie
    .split('; ')
    .find(c => c.includes('region'));
  let region = regionCookie && regionCookie.split('=')[1];

  if (region === 'korea') {
    $$('button .flag_en-gb ~ span').forEach(
      flag => (flag.textContent = 'Korea')
    );
    $$('button .flag_en-gb').forEach(flag =>
      flag.classList.replace('flag_en-gb', 'flag_ko')
    );
  } else if (region === 'india') {
    $$('button .flag_en-gb ~ span').forEach(
      flag => (flag.textContent = 'India')
    );
    $$('button .flag_en-gb').forEach(flag =>
      flag.classList.replace('flag_en-gb', 'flag_india')
    );
  } else if (region === 'asean') {
    $$('button .flag_en-gb ~ span').forEach(
      flag => (flag.textContent = 'ASEAN')
    );
    $$('button .flag_en-gb').forEach(flag =>
      flag.classList.replace('flag_en-gb', 'flag_region')
    );
  } else if (region === 'oceania') {
    $$('button .flag_en-gb ~ span').forEach(
      flag => (flag.textContent = 'Oceania')
    );
    $$('button .flag_en-gb').forEach(flag =>
      flag.classList.replace('flag_en-gb', 'flag_region')
    );
  }

  if (region === 'en-GB') {
    region = 'uk';
  }

  $$('[data-noderegions]').forEach(element => {
    var hasRegion = element.dataset.noderegions.includes(region);
    if (hasRegion === false) {
      element.remove();
    }
  });
});

if (
  window.personalizationManager &&
  window.location.href.indexOf('Sitefinity') === -1 &&
  window.location.href.indexOf('Preview') === -1
) {
  window.personalizationManager.addPersonalizedContentLoaded(function () {
    const mobileModalWindow = $(
      '#mobile-langModalWindow-d59db2ae-6952-47a4-88c2-6f09ec6dafcb'
    );
    const desktopModalWindow = $('#modal-window-language-selector-desktop');

    if (mobileModalWindow && desktopModalWindow) {
      manageLanguageModalWindow();
    }
  });
}

const setRegionCookie = region => {
  const date = new Date();
  const dateInMilliseconds = date.getTime();
  const expDays = 365;
  date.setTime(dateInMilliseconds + expDays * 24 * 60 * 60 * 1000);

  document.cookie = `region=${region};expires=${date.toUTCString()};path=/`;
  localStorage.setItem('region', region);
};

$$('.language-link[data-culture]').forEach(li => {
  const region = li.dataset.region;
  li.addEventListener('click', () => setRegionCookie(region));
});

setTimeout(() => {
  $$('a[href]').forEach(function (a) {
    if (a.href.indexOf('javascript') == 0) return;

    try {
      let link = new URL(a.href);
      if (link.host != document.location.host) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      console.error(e);
    }
  });
}, 0);

window.importSearchComponents = () => {
  return import('./components/search')
    .then(components => components)
    .catch(error => 'An error occurred while loading the module');
};

window.importComponents = () => {
  return import('./components')
    .then(components => components)
    .catch(error => 'An error occurred while loading the module');
};

$$('.grid-child-width-correction').forEach(s => {
  if (s.childElementCount <= s.dataset.slides)
    s.classList.add('grid-child-width-correction-remove@m');
});

$$('.switcher').forEach(el => {
  let container = el.closest('.uk-section');
  let itemsContainer = container.querySelector('.switcher-items');
  if (!itemsContainer) return;

  let tabs = itemsContainer.querySelectorAll('.uk-slider-container');
  let tabsIndex = 0;
  let removedTabs = 0;
  if (tabs.length > 0) {
    tabs.forEach(tab => {
      if (!tab.querySelector('.uk-card-title')) {
        let buttons = el.querySelectorAll('.uk-button');
        let currentButton = buttons[tabsIndex];
        removedTabs++;
        if (buttons.length >= tabsIndex) {
          currentButton.style.display = 'none';
          if (currentButton.classList.contains('uk-active')) {
            currentButton.classList.remove('uk-active');
          }
          if (buttons.length > tabsIndex + 1) {
            buttons[tabsIndex + 1].classList.add('uk-active');
          }
        }
      }

      tabsIndex++;
    });

    if (removedTabs == tabsIndex) {
      container.style.display = 'none';
    }
  }

  let uuid = btoa(Math.random().toString()).substr(0, 10);

  itemsContainer.setAttribute('data-uuid', uuid);

  UIkit.switcher(el, {
    toggle: el.dataset.switcherToggle,
    connect: '[data-uuid="' + uuid + '"]',
    swiping: false,
  });

  itemsContainer.classList.add('uk-switcher');
  itemsContainer.classList.remove('switcher-items-tmp');
});

$$('.scrollspy-nav').forEach((el, idx) => {
  if (window.sfEnv.isDesignMode) {
    return;
  }
  let itemsContainer = $$('.anchor-menu-items > div');
  if (!itemsContainer) {
    return;
  }

  let links = el.querySelectorAll('a');

  let navDropdownWrapper = el.querySelector('.scrollspy-nav__dropdown-wrapper');

  const mobileLinks = navDropdownWrapper.querySelectorAll(
    '.scrollspy-nav__anchor-links'
  );

  links.forEach((a, i) => {
    let element = itemsContainer[i];
    if (!element) return;

    let anchor = a.innerText.replaceAll(' ', '-') + '-' + (idx + 1);

    a.setAttribute('href', '#' + anchor);
    element.setAttribute('id', anchor);

    UIkit.scrollspyNav(el, { closest: 'a', scroll: false, offset: 110 });
  });

  if (navDropdownWrapper) {
    navDropdownWrapper.addEventListener('click', e => {
      navDropdownWrapper.classList.toggle('active');
      if (e.target.classList.contains('scrollspy-nav__anchor-links')) {
        mobileLinks.forEach(link => link.classList.remove('active'));
        scrollToSection(e, idx);

        UIkit.dropdown(navDropdownWrapper.querySelector('[uk-dropdown]')).hide(
          0
        );
      }
    });
  }

  window.addEventListener('scroll', () => {
    if (itemsContainer[0].getBoundingClientRect().top > 250) {
      return;
    }

    if (itemsContainer[0].getBoundingClientRect().top < 20) {
      navDropdownWrapper.classList.add('visible');
    } else {
      navDropdownWrapper.classList.remove('visible');
    }

    for (var i = 0; i < itemsContainer.length; i++) {
      var currentHeader = itemsContainer[i];
      var nextHeader = itemsContainer[i + 1];

      var currentHeaderBounding = currentHeader.getBoundingClientRect();
      var isInViewPort =
        currentHeaderBounding.top > 0 &&
        currentHeaderBounding.top < Math.ceil(window.innerHeight / 5);

      if (nextHeader && !isInViewPort) {
        isInViewPort =
          nextHeader.getBoundingClientRect().top >
            Math.ceil(window.innerHeight / 1.6) &&
          currentHeaderBounding.bottom < 0;
      }

      if (isInViewPort) {
        var sectionId = currentHeader.getAttribute('id');
        var href = '#' + sectionId;

        if (window.location.hash !== href) {
          history.replaceState(null, null, href);
        }

        const hashText = href
          .substring(1)
          .replace(/-/g, ' ')
          .replace(/\d+$/, '')
          .trim();

        const links = navDropdownWrapper.querySelectorAll(
          '.scrollspy-nav__anchor-links'
        );

        const activeLink = navDropdownWrapper.querySelector(
          '.scrollspy-nav__dropdown-active--text'
        );

        const pageBannerTitle = document.querySelector(
          '.page-banner-desc .uk-heading-large'
        );

        for (let i = 0; i < links.length; i++) {
          if (links[i].innerText.trim() === hashText) {
            links.forEach(link => link.classList.remove('active'));
            links[i].classList.add('active');

            activeLink.innerText = pageBannerTitle
              ? pageBannerTitle.innerText
              : hashText;
            break;
          }
        }

        return;
      }
    }
  });
});

function scrollToSection(e, idx) {
  const scrollOffset = 40;

  let anchor = e.target.innerText.replaceAll(' ', '-') + '-' + (idx + 1);

  const section = document.getElementById(anchor);

  window.location.href = window.location.href.split('#')[0] + '#' + anchor;

  const scrollPosition =
    section.getBoundingClientRect().top + window.pageYOffset - scrollOffset;

  window.scrollTo({
    top: scrollPosition,
  });

  e.target.classList.add('active');
}

$$('.img-wrp').forEach(wrp => {
  let img = wrp.querySelectorAll('img');

  img.forEach(el => {
    let realWidth = el.naturalWidth;
    let realHeight = el.naturalHeight;
    let ratio = realWidth / realHeight;
    let parent = el.closest('.img-wrp');

    if (realWidth > realHeight && realWidth >= 500 && ratio > 1.5) {
      parent.classList.add('img-wrp-cover');
    } else if (realHeight > realWidth && ratio < 0.8) {
      parent.classList.add('img-wrp-portrait');
    }
  });
});

$$('.tag-filter-wrp').forEach(el => {
  let btn = el.querySelector('.tag-filter-btn');
  let tags = Array.from(el.querySelectorAll('.tag-filter-hidden'));
  let startPos = 0;
  let count = +el.dataset.visibleItems;

  btn.addEventListener('click', () => {
    let endPos = startPos + count;
    tags.slice(0, endPos).forEach(tag => {
      tag.classList.remove('uk-hidden', 'tag-filter-hidden');
      tag.classList.add('uk-animation-scale-up');
    });
    startPos = endPos;
  });
});

const accordionWithTable = document.querySelectorAll(
  '.uk-accordion-content div:has(div table)'
);

if (accordionWithTable) {
  const accordionTitle = document.querySelectorAll(
    '.accordion-wrapper-layout .uk-accordion-title'
  );

  accordionTitle.forEach(title => {
    title.addEventListener('click', () => {
      setTimeout(() => {
        updateIndicator();
      }, 0);
    });
  });

  // Initial check on load
  window.addEventListener('load', updateIndicator);

  // Check on resize
  window.addEventListener('resize', updateIndicator);

  // Check on scroll
  document
    .querySelectorAll('.uk-accordion-content')
    .forEach(function (container) {
      container.addEventListener('scroll', function () {
        updateIndicator(); // Recheck table width on scroll
      });
    });
}

window.addEventListener('load', () => {
  const hotspots = document.querySelectorAll('.hotspot');

  if (hotspots) {
    hotspots.forEach(hotspot => {
      if (hotspot) {
        hotspot.style.display = 'block';
      }
    });
  }
});

function updateIndicator() {
  accordionWithTable.forEach(function (container) {
    const table = container.querySelector('table');
    if (table) {
      const tableWidth = table.offsetWidth;
      const viewportWidth = window.innerWidth;

      // Show or hide the indicator based on the table width
      if (tableWidth > viewportWidth) {
        container.classList.add('show-indicator');
      } else {
        container.classList.remove('show-indicator');
      }

      // Hide the indicator when scrolling
      container.addEventListener('scroll', function () {
        if (container.scrollLeft > 10) {
          container.classList.add('hide-indicator');
        }
      });
    }
  });
}

const container = document.getElementById('infographics-related-body-content');
const related = document.getElementById('content-body-infographics');
if (related) {
  if (container !== undefined && container !== null) {
    while (related.childNodes.length > 0) {
      container.appendChild(related.childNodes[0]);
    }
  } else {
    related.classList.remove('do-not-show');
  }
}

const { getComponent, util } = UIkit;
const { getIndex, on, ready } = util;

ready(() => {
  setTimeout(() => {
    const slideshow = $('#slideshow');
    const sliderComp = getComponent($('#thumb-nav'), 'slider');
    let counters = document.querySelectorAll('.counter');

    on(slideshow, 'itemshow', ({ detail, target }) => {
      if (target.getAttribute('uk-slideshow-item')) {
        counters.forEach(counter => {
          const currentSlidershowWrapper = counter.closest('#slideshow');

          if (currentSlidershowWrapper.contains(target)) {
            counter.innerText = target.getAttribute('aria-label');
          } else {
            counter.innerText = '0';
          }
        });
      }
      if (detail[0].$el === slideshow && sliderComp) {
        sliderComp.show(getIndex(target, target.parentNode.children));
      }
    });
  }, 500);
});

